import { Datagrid, DateField, List, TextField, TextInput, SimpleForm, Edit, Create, EditButton, required } from 'react-admin';

const validateForm = [required()];

export const Master_kabList = () => (
    <List>
        {/* <Datagrid rowClick="edit"> */}
        <Datagrid>
            <TextField source="id" />
            <TextField source="kode_prov" />
            <TextField source="nama_prov" />
            <TextField source="kode_kab" />
            <TextField source="nama_kab" />
            <EditButton />
        </Datagrid>
    </List>
);

export const Master_kabEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="id" validate={validateForm} />
            <TextInput source="kode_prov" validate={validateForm} />
            <TextInput source="nama_prov" validate={validateForm} />
            <TextInput source="kode_kab" validate={validateForm} />
            <TextInput source="nama_kab" validate={validateForm} />
        </SimpleForm>
    </Edit>
);

export const Master_kabCreate = () => (
    <Create>
        <SimpleForm>
            {/* <TextInput source="id" /> */}
            <TextInput source="kode_prov" />
            <TextInput source="nama_prov" />
            <TextInput source="kode_kab" />
            <TextInput source="nama_kab" />
        </SimpleForm>
    </Create>
);
